function msg_wishlist(msg){
    document.querySelector('.info-wishlist').style.display = 'flex';
    document.querySelector('.msg-wishlist').innerHTML = msg;
    setTimeout(()=>{
        document.querySelector('.info-wishlist').style.display = 'none';
    },3000)
}
document.addEventListener("DOMContentLoaded", function() {
    const wishlist_chiudi = document.querySelectorAll('.close-wishlist');
    wishlist_chiudi.forEach((btn)=>{
       btn.addEventListener('click',()=>{
           document.querySelector('.info-wishlist').style.display = 'none';
       })
    });
  let wishlist = JSON.parse(sessionStorage.getItem("wishlist")) || [];
  const btnW = document.querySelectorAll('.azioni-prodotto-logout');
    btnW.forEach((btn)=>{
      const productId = btn.getAttribute('data-prodotto');
      wishlist.forEach((item)=>{
        if(item==productId){
          btn.classList.add('attivo');
          btn.setAttribute('data-azione','remove');
        }
      })
      btn.addEventListener('click',()=>{
           if(btn.classList.contains('attivo')){
             wishlist = wishlist.filter(item => item !== productId);
             btn.classList.remove('attivo');
             btn.setAttribute('data-azione','add');
           }else{
             wishlist.push(productId);
             btn.classList.add('attivo');
             btn.setAttribute('data-azione','remove');
           }
          sessionStorage.setItem("wishlist", JSON.stringify(wishlist));
       })
    })
});